import React, { useRef, useState, useEffect } from "react";
import MediaModel from "../../MediaUpload/MediaModel";
import { Link, useNavigate, useParams } from "react-router-dom";
import { cartProducts as initialCartProducts } from "../../../../common/data/MyFackData";
import { useFormik } from "formik";
import * as Yup from "yup";
import {
  Badge,
  Button,
  Card,
  CardBody,
  CardText,
  CardTitle,
  Col,
  Container,
  FormFeedback,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
  Table,
  UncontrolledTooltip,
} from "reactstrap";
import Breadcrumbs from "../../../../components/Common/Breadcrumb";
import toast from "react-hot-toast";

const IndividualUserCartList = () => {
  const { id } = useParams(); // cart id
  const baseurl = process.env.REACT_APP_BASE_URL;
  const imgurl = process.env.REACT_APP_IMAGE_URL;

  const navigate = useNavigate();
  const imageInputRef = useRef(null);

  const [modal, setModal] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [cartDetails, setCartDetails] = useState(null);
  const [addProduct, setAddProduct] = useState(null);
  const [cartProducts, setCartProducts] = useState(initialCartProducts || []);

  const [uploadedImages, setUploadedImages] = useState(null);
  const [imageModel, setImageModel] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
const [error, setError] = useState(null);
  // Add Product modal state
const [addModal, setAddModal] = useState(false);

// Dropdown lists
const [displayData, setdisplayData] = useState([]);
const [categories, setCategories] = useState([]);
const [subCategories, setSubCategories] = useState([]);
const [subSubCategories, setSubSubCategories] = useState([]);
const [productsList, setProductsList] = useState([]);

// Selected Values
const [selecteddisplay, setselectedDisplay] = useState("");
const [selectedCategory, setSelectedCategory] = useState("");
const [selectedSubCategory, setSelectedSubCategory] = useState("");
const [selectedSubSubCategory, setSelectedSubSubCategory] = useState("");
const [selectedProduct, setSelectedProduct] = useState("");
const [selectedQty, setSelectedQty] = useState(1);
const [freightType, setFreightType] = useState("Freight Extra");

  // fetch cart details & items
  useEffect(() => {
       
    fetchCartDetails();
    fetchCartItems();
    // eslint-disable-next-line
  }, [id]);


const updateFreightType = async (type) => {
  try {
    setFreightType(type);

    const response = await fetch(
      `${baseurl}/admin/customer/update-freight`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          cart_no: id,
          freight_type: type,
        }),
      }
    );

    const data = await response.json();

    if (data.success) {
       toast.success('Freight type updated successfully!');
    }
  } catch (error) {
    console.error(error);
    toast.error("Failed to update freight type");
  }
};



  const DisplayNameData = async () => {
        try {
          setError(null); // Reset error before fetching
          const response = await fetch(`${baseurl}/admin/master/active-displaynames`);
          if (!response.ok) {
            throw new Error("Network response was not ok");
          }
          const data = await response.json();
          setdisplayData(data);
        } catch (error) {
          setError(error.message);
        }
      }; 
  // 1️⃣ Get Categories
const fetchCategories = async (displayId) => {
  try {
    const res = await fetch(`${baseurl}/admin/master/active-categories-by-id/${displayId}`);
    const data = await res.json();
    setCategories(data);
  } catch (e) {
    console.log("fetchCategories error", e);
  }
};

// 2️⃣ Sub Categories (depends on Category)
const fetchSubCategories = async (categoryId) => {
  try {
    const res = await fetch(`${baseurl}/admin/master/active-subcategories-by-id/${categoryId}`);
    const data = await res.json();
    setSubCategories(data);
  } catch (e) {
    console.log("fetchSubCategories error", e);
  }
};

// 3️⃣ Sub-Sub Categories
const fetchSubSubCategories = async (subCategoryId) => {
  try {
    const res = await fetch(`${baseurl}/admin/master/active-subsubcategories-by-id/${subCategoryId}`);
    const data = await res.json();
    setSubSubCategories(data);
  } catch (e) {
    console.log("fetchSubSubCategories error", e);
  }
};

// 4️⃣ Products
const fetchProductsBySubSub = async (subSubId) => {
  try {
    const res = await fetch(`${baseurl}/admin/products/active-products/${subSubId}`);
    const data = await res.json();
    setProductsList(data);
  } catch (e) {
    console.log("fetchProducts error", e);
  }
};

  const fetchCartDetails = async () => {
  try {
    const res = await fetch(
      `${baseurl}/admin/customer/individuals/cart/${id}`
    );

    const data = await res.json();

    if (data.success && data.data) {
      setCartDetails(data.data);

      // Set freight type
      if (data.data.freight_type) {
        setFreightType(data.data.freight_type);
      }

      // Mark cart as viewed
      await fetch(
        `${baseurl}/admin/customer/individuals/cart/${id}/viewed`,
        {
          method: "PUT",
        }
      );
    }
  } catch (err) {
    console.error("fetchCartDetails:", err);
  }
};

  const fetchCartItems = async () => {
    try {
      const res = await fetch(`${baseurl}/admin/customer/individuals/cart-items/${id}`);
      const data = await res.json();
      setCartProducts(Array.isArray(data.data) ? data.data : []);
    } catch (err) {
      console.error("fetchCartItems:", err);
    }
  };

  const toggleImageModal = () => {
    setImageModel(!imageModel);
    setSelectedImage([]);
  };

  const handleUploadImage = (image) => {
    if (image) setUploadedImages([image?.image]);
    toggleImageModal();
    setSelectedImage(null);
  };

  const handleImageChange = (event) => {
    const file = event.target.files?.[0];
    if (!file) return;
    const newImage = Object.assign(file, { preview: URL.createObjectURL(file) });
    setUploadedImages([newImage]);
  };

  const addProductToCart = async () => {
  if (!selectedProduct || !selectedQty) {
    alert("Please select product & quantity");
    return;
  }

  try {
    const payload = {
      cart_no: id,
      product_id: selectedProduct,
      quantity: selectedQty,
      user_id: cartDetails?.user_id
    };

    const res = await fetch(`${baseurl}/admin/customer/individuals/cart-items`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload)
    });

    const data = await res.json();

    if (data.success) {
      fetchCartItems(); // refresh
      setAddModal(false);
      setSelectedCategory("");
      setSelectedSubCategory("");
      setSelectedSubSubCategory("");
      setSelectedProduct("");
      setSelectedQty(1);
    } else {
      alert(data.message);
    }
  } catch (err) {
    console.log(err);
    alert("Error adding product");
  }
};

  // ======================
  // API: DELETE cart item
  // ======================
  const removeCartItem = async (itemId) => {
    if (!itemId) return;
    try {
      const res = await fetch(`${baseurl}/admin/customer/individuals/cart-items/${itemId}`, {
        method: "DELETE",
      });
      const data = await res.json();

      if (data.success || res.status === 200 || res.status === 204) {
        // remove from UI
        setCartProducts((prev) => prev.filter((p) => p.id !== itemId));
        setDeleteModal(false);
      } else {
        alert(data.message || "Failed to delete item");
      }
      fetchCartItems();
    } catch (error) {
      console.error("removeCartItem:", error);
      alert("Error deleting item");
    }
  };

  // ======================
  // OPEN EDIT modal (quantity & discount only)
  // ======================
  const handleEditClick = (product) => {
    setAddProduct(product);
    setIsEdit(true);
    setModal(true);
  };

  const toggleModal = () => setModal(!modal);

  // Delete modal state
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteProductId, setDeleteProductId] = useState(null);
  const DeleteProduct = (id) => {
    setDeleteProductId(id);
    setDeleteModal(true);
  };

  // ======================
  // Summary calculation
  // ======================
  const calculateSummary = () => {
  let subtotal = 0;
  let discountTotal = 0;
  let taxTotal = 0;
  let shipping = 0;

  (cartProducts || []).forEach((item) => {
    const price = Number(item.price) || 0;
    const quantity = Number(item.quantity) || 0;
    const discount = Number(item.discount) || 0;
    const igst = Number(item.igst) || 0;

    const discountedPrice = price - (price * discount) / 100;
    const itemAmount = discountedPrice * quantity;
    const taxAmount = itemAmount * (igst / 100);

    subtotal += itemAmount + taxAmount; // GST included
    discountTotal += (price * discount) / 100 * quantity;
    taxTotal += taxAmount;
  });

  return {
    subtotal,          // Includes GST
    discountTotal,
    shipping,
    taxTotal,
    grandTotal: subtotal + shipping,
  };
};

  const summary = calculateSummary();

  // ======================
  // Formik - edit only quantity & discount
  // ======================
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      id: addProduct?.id || "",
      quantity: addProduct?.quantity || 1,
      discount: addProduct?.discount || 0, // percent
      purchase_price: addProduct?.purchase_price || 0,
      mrp: addProduct?.price || 0,
    },
    validationSchema: Yup.object({
      quantity: Yup.number().required("Enter quantity").min(1, "Min 1"),
      discount: Yup.number().min(0).max(100),
    }),
    onSubmit: async (values) => {
      // only update quantity & discount
      if (!isEdit) {
        // For this request we only support editing existing items.
        toggleModal();
        return;
      }

      try {
        const payload = {
          quantity: Number(values.quantity),
          discount: Number(values.discount),
        };

        const res = await fetch(
          `${baseurl}/admin/customer/individuals/cart-items/${values.id}`,
          {
            method: "PUT", // your API expects PUT
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(payload),
          }
        );

        const data = await res.json();

        if (data.success) {
          // Use returned item if API gives it, otherwise update local item
          const updatedItem = data.data
            ? data.data
            : (prev => ({ ...prev, ...payload }));

          setCartProducts((prev) =>
            prev.map((p) => (p.id === values.id ? (data.data ? data.data : { ...p, ...payload }) : p))
          );

          toggleModal();
        } else {
          alert(data.message || "Update failed");
        }
        fetchCartItems();
      } catch (err) {
        console.error("updateCartItem:", err);
        alert("Error updating item");
      }
    },
  });
useEffect(() => {
  if (cartDetails?.freight_type && !freightType) {
    setFreightType(cartDetails.freight_type);
  }
}, [cartDetails]);
useEffect(() => {
  console.log("freightType =", freightType);
}, [freightType]);

  return (
    <>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs
            title="Individual Customer Cart"
            breadcrumbItem={`Cart List (${cartDetails?.cart_no ?? "—"})`}
          />
          <Row>
            <Col xl={12}>
              <Card>
                <CardBody>
                  <div className="d-flex justify-content-between">
                    <div className="text-sm-end">
                      <Button
                        type="button"
                        color="primary"
                        className="btn mb-2 me-2 d-flex align-items-center"
                        onClick={() => navigate(-1)}
                      >
                        <i className="bx bx-arrow-back me-1"></i>
                        Back to Cart
                      </Button>
                    </div>

                    {/* If you want to allow adding products, keep Add Product button.
                        Since user asked only for edit/remove, button is hidden when cart inactive */}
                    {cartDetails?.status === "Active" && (
                      <div className="text-sm-end">
                        <Button
                          type="button"
                          color="success"
                          className="btn mb-2 me-2"
                          onClick={() => {
                            // open a modal for add if you want - currently not implemented
                            DisplayNameData();
    setAddModal(true);
                          }}
                        >
                          <i className="mdi mdi-plus-circle-outline me-1" />
                          Add Product
                        </Button>
                      </div>
                    )}
                  </div>

                  <Card className="mb-3">
                    <CardBody>
                      <CardTitle tag="h5" className="text-primary fw-bold mb-3">
                        Customer Details
                      </CardTitle>
                      <Row>
                        <Col md="4">
                          <CardText>
                            <strong>User ID:</strong> {cartDetails?.user_id}
                          </CardText>
                          <CardText>
                            <strong>User Name:</strong> {cartDetails?.user_name}
                          </CardText>
                          <CardText>
                            <strong>Mobile Number:</strong> {cartDetails?.mobile_number}
                          </CardText>
                          <CardText>
                            <strong>Email:</strong> {cartDetails?.email}
                          </CardText>
                        </Col>
                        <Col md="4">
                          <CardText>
                            <strong>Company Name:</strong> {cartDetails?.company_name}
                          </CardText>
                          <CardText>
                            <strong>Gst Number:</strong> {cartDetails?.gst_number}
                          </CardText>
                          <CardText>
                            <strong>Pan Number:</strong> {cartDetails?.pan_number}
                          </CardText>
                          <CardText>
                            <strong>Company Email:</strong> {cartDetails?.company_email}
                          </CardText>
                        </Col>
                        <Col md="4">
                          <CardText>
                            <strong>Discount:</strong> {cartDetails?.discount} %
                          </CardText>
                          <CardText>
                            <strong>Type:</strong> {cartDetails?.type}
                          </CardText>
                          <CardText>
                            <strong>Status:</strong> {cartDetails?.status}
                          </CardText>
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>

                  <div className="table-responsive">
                    <Table className="table align-middle mb-0 table-nowrap">
                      <thead className="table-light">
                        <tr>
                          <th>#</th>
                          <th>Image</th>
                          <th>Product Desc</th>
                          <th>Price</th>
                          <th>Quantity</th>
                          <th>Discount(%)</th>
                          <th>Discount Price</th>
                          <th>IGST</th>
                          <th>Sub Total</th>
                          {cartDetails?.status === "Active" && <th>Action</th>}
                        </tr>
                      </thead>
                      <tbody>
                        {cartProducts?.length > 0 ? (
                          cartProducts.map((product, index) => {
                            const price = Number(product.price) || 0;
                            const qty = Number(product.quantity) || 0;
                            const discount = Number(product.discount) || 0;
                            const igst = Number(product.igst) || 0;

                            const discountedPrice = price - (price * discount) / 100;
                            const itemSubtotal = discountedPrice * qty;
                            const taxAmount = itemSubtotal * (igst / 100);
                            const rowTotal = itemSubtotal + taxAmount;

                            return (
                              <tr key={product.id || index}>
                                <td>{index + 1}</td>
                                <td>
                                  <img
                                    src={product.fileurl ? `${imgurl}${product.fileurl}` : "/images/no-image.png"}
                                    alt="product-img"
                                    title="product-img"
                                    className="avatar-md"
                                  />
                                </td>
                                <td>
                                  <h5 className="font-size-14 text-truncate">
                                    <Link to="#" className="text-dark">
                                      {product?.product_name}
                                    </Link>
                                  </h5>
                                  <p className="mb-0">
                                    M Part No :{" "}
                                    <span className="fw-medium">
                                      {product?.manufacturer_part_no}
                                    </span>
                                  </p>
                                </td>
                                <td>₹ {price.toFixed(2)}</td>
                                <td>{qty}</td>
                                <td>{discount} %</td>
                                <td>₹ {discountedPrice.toFixed(2)}</td>
                                <td>{igst} %</td>
                                <td>₹ {rowTotal.toFixed(2)}</td>

                                {cartDetails?.status === "Active" && (
                                  <td>
                                    <div className="d-flex gap-3 align-items-center">
                                      <Link
                                        to="#"
                                        className="action-icon text-success"
                                        onClick={() => handleEditClick(product)}
                                      >
                                        <i className="mdi mdi-pencil font-size-18" id={`edittooltip-${product.id}`} />
                                        <UncontrolledTooltip placement="top" target={`edittooltip-${product.id}`} fade={false} transition={{ timeout: 0 }}>
                                          Edit Cart
                                        </UncontrolledTooltip>
                                      </Link>

                                      <Link
                                        to="#"
                                        onClick={() => DeleteProduct(product.id)}
                                        className="action-icon text-danger"
                                      >
                                        <i className="mdi mdi-trash-can font-size-18" id={`removetooltip-${product.id}`} />
                                        <UncontrolledTooltip placement="top" target={`removetooltip-${product.id}`} fade={false} transition={{ timeout: 0 }}>
                                          Remove
                                        </UncontrolledTooltip>
                                      </Link>
                                    </div>
                                  </td>
                                )}
                              </tr>
                            );
                          })
                        ) : (
                          <tr>
                            <td colSpan={cartDetails?.status === "Active" ? 10 : 9} className="text-center">
                              No Data Found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </div>
                </CardBody>
              </Card>
            </Col>

            <Col xl={8}>
  <Card>
    <CardBody>
      <CardTitle className="mb-3">Freight Charges</CardTitle>

      <Label>Freight Type</Label>

      <Input
        type="select"
        value={freightType}
        disabled={["Converted", "Expired"].includes(cartDetails?.status)}
        onChange={(e) => {
          setFreightType(e.target.value);
          updateFreightType(e.target.value);
        }}
      >
        <option value="Freight Extra">Freight Extra</option>
        <option value="Freight Inclusive">Freight Inclusive</option>
      </Input>

      
    </CardBody>
  </Card>
</Col>

            <Col xl={4}>
              <Card>
                <CardBody>
                  <CardTitle className="mb-3">Order Summary</CardTitle>

                  <div className="table-responsive">
                    <Table className="table mb-0">
                      <tbody>
                        <tr>
                          <td>Subtotal :</td>
                          <td>₹ {summary.subtotal.toFixed(2)}</td>
                        </tr>
                        <tr>
                          <td>Discount :</td>
                          <td>- ₹ {summary.discountTotal.toFixed(2)}</td>
                        </tr>
              
                        <tr>
                          <th>Total :</th>
                          <th>₹ {summary.grandTotal.toFixed(2)}</th>
                        </tr>
                      </tbody>
                    </Table>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>

          <Modal isOpen={addModal} toggle={() => setAddModal(false)} backdrop="static" size="md">
  <ModalHeader toggle={() => setAddModal(false)} tag="h4">
    Add Product to Cart
  </ModalHeader>

  <ModalBody>
    <Row>
      {/* Category */}
      <Col md={12} className="mb-3">
        <Label>Display Name</Label>
        <Input
          type="select"
          value={selecteddisplay}
          onChange={(e) => {
            setselectedDisplay(e.target.value);
            fetchCategories(e.target.value);
            setSubCategories([]);
            setSubSubCategories([]);
            setProductsList([]);
            setSelectedSubCategory("");
            setSelectedSubSubCategory("");
            setSelectedProduct("");
          }}
        >
          <option value="">Select Display Name</option>
          {displayData.map((display) => (
            <option key={display.id} value={display.id}>
              {display.displayname}
            </option>
          ))}
        </Input>
      </Col>
      {/* Category */}
      <Col md={12} className="mb-3">
        <Label>Category</Label>
        <Input
          type="select"
          value={selectedCategory}
          disabled={!selecteddisplay}
          onChange={(e) => {
            setSelectedCategory(e.target.value);
            fetchSubCategories(e.target.value);
            setSubCategories([]);
            setSubSubCategories([]);
            setProductsList([]);
            setSelectedSubCategory("");
            setSelectedSubSubCategory("");
            setSelectedProduct("");
          }}
        >
          <option value="">Select Category</option>
          {categories.map((cat) => (
            <option key={cat.id} value={cat.id}>
              {cat.categoryname}
            </option>
          ))}
        </Input>
      </Col>

      {/* Sub Category */}
      <Col md={12} className="mb-3">
        <Label>Sub Category</Label>
        <Input
          type="select"
          value={selectedSubCategory}
          disabled={!selectedCategory}
          onChange={(e) => {
            setSelectedSubCategory(e.target.value);
            fetchSubSubCategories(e.target.value);
            setSelectedSubSubCategory("");
            setSelectedProduct("");
          }}
        >
          <option value="">Select Sub Category</option>
          {subCategories.map((sub) => (
            <option key={sub.id} value={sub.id}>
              {sub.subcategoryname}
            </option>
          ))}
        </Input>
      </Col>

      {/* Sub Sub Category */}
      <Col md={12} className="mb-3">
        <Label>Sub Sub Category</Label>
        <Input
          type="select"
          value={selectedSubSubCategory}
          disabled={!selectedSubCategory}
          onChange={(e) => {
            setSelectedSubSubCategory(e.target.value);
            fetchProductsBySubSub(e.target.value);
            setSelectedProduct("");
          }}
        >
          <option value="">Select Sub-Sub Category</option>
          {subSubCategories.map((ss) => (
            <option key={ss.id} value={ss.id}>
              {ss.subsub_categoryname}
            </option>
          ))}
        </Input>
      </Col>

      {/* Products */}
      <Col md={12} className="mb-3">
        <Label>Product</Label>
        <Input
          type="select"
          value={selectedProduct}
          disabled={!selectedSubSubCategory}
          onChange={(e) => setSelectedProduct(e.target.value)}
        >
          <option value="">Select Product</option>
          {productsList.map((p) => (
            <option key={p.id} value={p.id}>
              {p.product_name}
            </option>
          ))}
        </Input>
      </Col>

      {/* Quantity */}
      <Col md={12} className="mb-3">
        <Label>Quantity</Label>
        <Input
          type="number"
          min="1"
          value={selectedQty}
          onChange={(e) => setSelectedQty(e.target.value)}
        />
      </Col>
    </Row>

    <Row>
      <Col className="text-end mt-3">
        <Button color="success" onClick={addProductToCart}>Add Product</Button>
      </Col>
    </Row>
  </ModalBody>
</Modal>

          {/* =======================
    Modal: Edit Quantity & Discount
======================= */}
<Modal
  isOpen={modal}
  toggle={toggleModal}
  backdrop="static"
  keyboard={false}
  size="md"
>
  <ModalHeader toggle={toggleModal} tag="h4">
    Edit Quantity & Discount
  </ModalHeader>

  <ModalBody>
    <form onSubmit={formik.handleSubmit}>
      <Row>
        {/* ================= Quantity ================= */}
        <Col className="col-12 mb-3">
          <Label className="form-label">Quantity</Label>
          <Input
            name="quantity"
            type="number"
            min="1"
            value={formik.values.quantity}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            invalid={formik.touched.quantity && !!formik.errors.quantity}
          />
          {formik.touched.quantity && formik.errors.quantity && (
            <FormFeedback>{formik.errors.quantity}</FormFeedback>
          )}
        </Col>

        {/* ================= Discount ================= */}
        <Col className="col-12 mb-3">
          <Label className="form-label">Discount (%)</Label>
          <Input
            name="discount"
            type="number"
            min="0"
            step="0.01"
            value={formik.values.discount}
            onChange={(e) => {
              const value = Number(e.target.value);
              const mrp = Number(formik.values.mrp || 0);
              const purchase = Number(formik.values.purchase_price || 0);
              
              const maxDiscount =
                mrp > 0 ? ((mrp - purchase) / mrp) * 100 : 0;

              // 🔒 Auto-cap discount
              if (value > maxDiscount) {
                formik.setFieldValue("discount", maxDiscount.toFixed(2));
              } else {
                formik.setFieldValue("discount", value);
              }
            }}
            onBlur={formik.handleBlur}
          />
        </Col>

        {/* ================= Calculation Preview ================= */}
        
<Col className="col-12">
  {(() => {
    const mrp = Number(formik.values.mrp || 0);
    const purchase = Number(formik.values.purchase_price || 0);
    const discount = Number(formik.values.discount || 0);

    // 🔹 Discount calculation
    const discountAmount = (mrp * discount) / 100;
    const finalSalePrice = mrp - discountAmount;

    // 🔹 Profit / Loss status
    let statusText = "Profit";
    let statusTextClass = "text-success";
    let statusBgClass = "bg-success-subtle";

    if (finalSalePrice === purchase) {
      statusText = "No Profit";
      statusTextClass = "text-warning";
      statusBgClass = "bg-warning-subtle";
    } else if (finalSalePrice < purchase) {
      statusText = "Loss";
      statusTextClass = "text-danger";
      statusBgClass = "bg-danger-subtle";
    }

    // 🔹 Margin %
    const marginPercent =
      purchase > 0
        ? ((finalSalePrice - purchase) / purchase) * 100
        : 0;

    // 🔹 Margin band
    let marginLabel = "Margin Below 7%";
    let marginBg = "bg-danger";
    let marginText = "text-white";

    if (marginPercent > 28) {
      marginLabel = "Margin Above 28%";
      marginBg = "bg-success";
    } else if (marginPercent >= 15) {
      marginLabel = "Margin Between 15% - 28%";
      marginBg = "bg-success-subtle";
      marginText = "text-success";
    } else if (marginPercent >= 7) {
      marginLabel = "Margin Between 7% - 15%";
      marginBg = "bg-warning";
      marginText = "text-dark";
    }

    return (
      <>
        {/* 🔹 Price Summary */}
        <div className={`p-3 rounded border mb-2 ${statusBgClass}`}>
          <p className="mb-1">
            <strong>Purchase Price:</strong> ₹{purchase.toFixed(2)}
          </p>
          <p className="mb-1">
            <strong>MRP:</strong> ₹{mrp.toFixed(2)}
          </p>
          <p className="mb-1">
            <strong>Discount Amount:</strong> ₹{discountAmount.toFixed(2)}
          </p>
          <h5 className={statusTextClass}>
            Final Sale Price: ₹{finalSalePrice.toFixed(2)}
          </h5>
          <small className={statusTextClass}>
            Status: {statusText}
          </small>
        </div>

        {/* 🔹 Margin Band */}
        <div className={`p-2 rounded fw-bold text-center ${marginBg} ${marginText}`}>
          {marginLabel} ({marginPercent.toFixed(2)}%)
        </div>
      </>
    );
  })()}
</Col>

      </Row>

      {/* ================= Submit ================= */}
      <Row className="mt-3">
        <Col className="text-end">
          <Button
            type="submit"
            color="success"
            disabled={
              Number(formik.values.mrp) -
                (Number(formik.values.mrp) *
                  Number(formik.values.discount)) /
                  100 <
              Number(formik.values.purchase_price)
            }
          >
            Update
          </Button>
        </Col>
      </Row>
    </form>
  </ModalBody>
</Modal>


          {/* Delete confirmation modal */}
          <Modal size="sm" isOpen={deleteModal} toggle={() => setDeleteModal(false)} centered={true}>
            <div className="modal-content">
              <ModalBody className="px-4 py-5 text-center">
                <button type="button" onClick={() => setDeleteModal(false)} className="btn-close position-absolute end-0 top-0 m-3"></button>
                <div className="avatar-sm mb-4 mx-auto">
                  <div className="avatar-title bg-primary text-primary bg-opacity-10 font-size-20 rounded-3">
                    <i className="mdi mdi-trash-can-outline"></i>
                  </div>
                </div>
                <p className="text-muted font-size-16 mb-4">Are you sure you want to permanently remove this product?</p>

                <div className="hstack gap-2 justify-content-center mb-0">
                  <button type="button" className="btn btn-danger" onClick={() => removeCartItem(deleteProductId)}>
                    Delete Now
                  </button>
                  <button type="button" className="btn btn-secondary" onClick={() => setDeleteModal(false)}>
                    Close
                  </button>
                </div>
              </ModalBody>
            </div>
          </Modal>

          {/* MediaModel (kept though not used in edit flow) */}
          <MediaModel
            imageModel={imageModel}
            toggleModal={toggleImageModal}
            handleUploadImage={handleUploadImage}
            selectedImage={selectedImage}
            setSelectedImage={setSelectedImage}
          />
        </Container>
      </div>
    </>
  );
};

export default IndividualUserCartList;
